import React, { Component } from "react"
import Proptypes from "prop-types"
import { Row, Col } from "reactstrap"
import LernMoreButton from "../Buttons/learnMoreCardButton"

class EachBlog extends Component {
  render(props) {
    return (
      <div className="each-blog">
        <Row>
          <Col xs="4" className="image">
            <img
              src={this.props.image}
              alt="learn about jitsi meet installation, configuration, customization and scalling to thusands or concurrent users"
            ></img>
          </Col>
          <Col xs="8" className="details">
            <div className="details-wrapper">
              <div className="type">Blog</div>
              <div className="title small-font">{this.props.title}</div>
              <LernMoreButton
                linkTitle="READ MORE"
                learnMore={this.props.readMore}
              />
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}
EachBlog.propTypes = {
  image: Proptypes.any,
  type: Proptypes.any,
  title: Proptypes.any,
  readMore: Proptypes.any,
}

export default EachBlog
